import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@rewards-web/shared/style/global-styles";

import { App } from "./app";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
